/**
 * A âncora da ficha (E203.F5.C, F-E203.F5-01): o endereço que chega com `#ficha-da-leitura` (ao
 * entrar, ou quando o hash muda com a mesa aberta) pede a ficha aberta, mesmo sem divergência; o
 * mesmo link de novo (outra `key`) pede de novo. Fora de um roteador não há âncora e nada acontece.
 */
import { useEffect } from 'react';
import { useInRouterContext, useLocation } from 'react-router-dom';

export const ANCORA_DA_FICHA = 'ficha-da-leitura';

function OuvirAncora({ onPedido }: { onPedido: () => void }): null {
  const { hash, key } = useLocation();
  const pediu = hash.length > 1 && decodeURIComponent(hash.slice(1)) === ANCORA_DA_FICHA;
  useEffect(() => {
    if (pediu) onPedido();
  }, [pediu, key, onPedido]);
  return null;
}

export function AncoraDaFicha({ onPedido }: { onPedido: () => void }): JSX.Element | null {
  return useInRouterContext() ? <OuvirAncora onPedido={onPedido} /> : null;
}
